"use client"

import { getSiteUrl } from "@repo/shared"
import { buildMetrixUrl, useMetrixLocale } from "@repo/ui/utils"
import Image from "next/image"
import Link from "next/link"
import React from "react"

import { HeaderUserInfo, UtilityNavItem } from "../../../../interface"
import GradientText from "../../../GradientText"
import { TopUtilityBarClient } from "./TopUtilityBarClient"

import "../../index.scss"

interface TopUtilityBarProps {
  utilityNav: UtilityNavItem[]
  userInfo: HeaderUserInfo | null
}

/**
 * 顶部工具导航栏组件（服务端组件）
 * - 左侧导航链接：服务端渲染（SSR），减少客户端 JS
 * - 右侧用户操作：客户端组件处理交互
 */
export const TopUtilityBar: React.FC<TopUtilityBarProps> = ({ utilityNav, userInfo }) => {
  const metrixLocale = useMetrixLocale()

  return (
    <div className="topUtilityBar">
      <div className="container">
        <div className="topUtilityBarContent">
          {/* 左侧导航链接 - SSR 渲染 */}
          <div className="topUtilityBarLeft">
            <Link href={buildMetrixUrl("/", metrixLocale)} className="aiLink" target="_blank">
              <Image src={`https://imgqn.smm.cn/static/image/metal/ai-logo.svg`} alt="logo" width={18} height={18} />
              <GradientText colors={["#ff9ffc", "#66b0ff", "#f2caca"]} animationSpeed={4} showBorder={false}>
                Metrix
              </GradientText>
            </Link>
            {utilityNav.map((item) => (
              <React.Fragment key={item.href}>
                <Link href={getSiteUrl("www") + item.href} className="utilityLink">
                  {item.label}
                </Link>
              </React.Fragment>
            ))}
            <div className="dividerLine" />
          </div>

          {/* 右侧用户操作 - 客户端组件 */}
          <TopUtilityBarClient userInfo={userInfo} />
        </div>
      </div>
    </div>
  )
}
